// extracted by mini-css-extract-plugin
export default {"preview":"zCq8g","icon":"cIV_D","button":"kSCnj"};